import s from "./CdrImg.vue2.mjs";
import o from "./styles/CdrImg.module.scss.mjs";
import t from "../../_virtual/_plugin-vue_export-helper.mjs";
const r = {
  $style: o
}, f = /* @__PURE__ */ t(s, [["__cssModules", r]]);
export {
  f as default
};
